import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldIconFragmentGql } from './FieldIconFragmentGql';

/* This query is used on the same page as DatasourceFieldsWithInheritanceByIdQueryGql is. If you modify this query, please also modify
 * the other to accommodate the feature flag being both on and off.
 */
export const DatasourceFieldsByIdQueryGql: DocumentNode = gql`
query DatasourceFieldsByIdQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    id
    name
    vizportalUrlId
    fieldsConnection(filter: { isHidden: false }, first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        id
        name
        description
        downstreamSheetsConnection {
          totalCount
        }
        ...FieldIconFragment
      }
    }
  }
}
${FieldIconFragmentGql}
`;
